import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api'
import { useT } from '@/i18n/I18nProvider'

interface Member { id: string; userId: string; role: string; createdAt: string }

export function TeamPage() {
  const t = useT()
  const members = useQuery({
    queryKey: ['members'],
    queryFn: () => apiClient.get<{ data: Member[] }>('/tenants/current/members'),
  })

  if (members.isLoading) return <p>{t('common.loading')}</p>
  if (members.isError || !members.data) return <p>{t('common.error')}</p>

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-4">{t('settings.team.title')}</h1>
      <p className="text-sm opacity-70 mb-4">{t('settings.team.subtitle')}</p>
      <table className="w-full text-sm border-collapse">
        <thead>
          <tr className="text-left opacity-70">
            <th className="py-2 pr-4">{t('settings.team.column.user')}</th>
            <th className="py-2 pr-4">{t('settings.team.column.role')}</th>
            <th className="py-2 pr-4">{t('settings.team.column.added')}</th>
          </tr>
        </thead>
        <tbody>
          {members.data.data.map((m) => (
            <tr key={m.id} className="border-t" style={{ borderColor: 'var(--color-border)' }}>
              <td className="py-2 pr-4 font-mono text-xs">{m.userId.slice(0, 8)}…</td>
              <td className="py-2 pr-4">{m.role}</td>
              <td className="py-2 pr-4">{new Date(m.createdAt).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="text-xs opacity-60 mt-4">{t('settings.team.invite.coming')}</p>
    </div>
  )
}
